export const data = [
    {
      id: 1,
      name: "Party dress",
      searchTerm: "dress",
      price: 300.99,
      image: "https://images.unsplash.com/photo-1631234764568-996fab371596?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZHJlc3Nlc3xlbnwwfHwwfHx8MA%3D%3Dg"
    },
    {
      id: 2,
      name: "Summer dress",
      searchTerm: "dress",
      price: 204.99,
      image: "https://images.unsplash.com/photo-1513112021388-3b047a81a909?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NjB8fHN1bW1lciUyMGRyZXNzfGVufDB8fDB8fHww"
    },
    {
      id: 3,
      name: "Fancy pants",
      searchTerm: "pants",
      price: 199.99,
      image: "https://images.unsplash.com/photo-1764698192249-641a17d7a4fe?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjE3fHxmYW5jeSUyMHBhbnRzfGVufDB8fDB8fHww"
    },
    {
      id: 4,
      name: "Jeans",
      searchTerm: "pants",
      price: 100.99,
      image: "https://plus.unsplash.com/premium_photo-1727894730957-e714035b458e?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjUwfHxmYW5jeSUyMHBhbnRzfGVufDB8fDB8fHww"
    },
    {
      id: 5,
      name: "Cute skirt",
      searchTerm: "skirt",
      price: 300.99,
      image: "https://images.unsplash.com/photo-1490092374320-1ca36d69ff6a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8d29tYW4lMjBza2lydHxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=300&q=60"
    },
    {
      id: 6,
      name: "Beauty",
      searchTerm: "skirt",
      price: 278.99,
      image: "https://images.unsplash.com/photo-1594226801341-41427b4e5c22?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fHNraXJ0fGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
    {
      id: 7,
      name: "Business meeting",
      searchTerm: "shirt",
      price: 285.99,
      image: "https://plus.unsplash.com/premium_photo-1769290472589-21ee2338dca4?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzM0fHxmYW5jeSUyMHBhbnRzfGVufDB8fDB8fHww"
    },
    {
      id: 8,
      name: "Lunch with friends",
      searchTerm: "shirt",
      price: 284,
      image: "https://plus.unsplash.com/premium_photo-1694618624694-b3ef348d6db8?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzQyfHxmYW5jeSUyMHBhbnRzfGVufDB8fDB8fHww"
    },
    {
      id: 9,
      name: "Carrie shoes",
      searchTerm: "shoes",
      price: 305.99,
      image: "https://images.unsplash.com/photo-1573100925118-870b8efc799d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8aGVlbHN8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
    },
    {
      id: 10,
      name: "Amanda shoes",
      searchTerm: "shoes",
      price: 305.99,
      image: "https://images.unsplash.com/photo-1627631457335-d1041fd0cb8c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fGhlZWxzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60"
    },
    {
      id: 11,
      name: "Miranda shoes",
      searchTerm: "shoes",
      price: 305.99,
      image: "https://images.unsplash.com/photo-1611233299310-f6276ff55307?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTQ5fHxzaG9lc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=300&q=60"
    },
    {
      id: 12,
      name: "Cute dress",
      searchTerm: "dress",
      price: 305.99,
      image: "https://images.unsplash.com/photo-1534875756527-5e8e4392005f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzc0fHxkcmVzc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=300&q=60"
    },
    {
      id: 13,
      name: "Pants",
      searchTerm: "pants",
      price: 100.99,
      image: "https://plus.unsplash.com/premium_photo-1675106697462-9ab93a450112?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NjF8fHRyb3VzZXJzfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=300&q=60"
    },
    {
      id: 14,
      name: "Lunch with friends",
      searchTerm: "skirt",
      price: 284,
      image: "https://images.unsplash.com/photo-1698401975448-38dee46d2ef0?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzY4fHxza2lydHxlbnwwfHwwfHx8MA%3D%3D"
    },
    {
      id: 15,
      name: "Lunch with friends",
      searchTerm: "shirt",
      price: 284.99,
      image: "https://plus.unsplash.com/premium_photo-1678388571761-9e787e202913?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDI1fHxmYW5jeSUyMHBhbnRzfGVufDB8fDB8fHww"
    }
  ]